/**
 * Generate a new UUID
 * @param {Number} length Character length
 */
const uuid = length => [...Array(length || 8)].map(() => (~~(Math.random() * 36)).toString(36)).join('');

export default uuid;
